<script setup>
import { binder } from '.'
defineProps(['is', 'text'])
</script>
<template>
  <component :is="is" v-bind="binder">
    {{ text }}
    <slot />
  </component>
</template>
